import { useContext, useEffect, useState } from "react"

import { Button, Col, Container, Row } from "reactstrap"

import { ScenarioContext } from "../../contexts/ScenarioContext"

import IntvForm      from "../forms/IntvForm"

const SectionLayout = ({top, bottom}) => {
    const { scenario, currIntv } = useContext(ScenarioContext)
    const [form, setForm] = useState(null)

    useEffect(() => {
        if (!!currIntv) {
            setForm(scenario.interventionForms[currIntv])
        } else {
            setForm(null)
        }
    }, [currIntv])

    return (
        <Container fluid={true} className="phase-container">
            <Row className="checklist-row">
                <Col md="12" className="phase-left-col">
                    {top}
                </Col>
            </Row>
            <Row className="patient-status-row">
                <Col md="12" className="patient-status-col">
                    {bottom}
                </Col>
            </Row>
        </Container>

    )
}

export default SectionLayout